import Player from './Player.js'
import Vector from '../Vector.js'
import PlayerKeyUp from '../Message/Outgoing/PlayerKeyUp.js'
import PlayerKeyDown from '../Message/Outgoing/PlayerKeyDown.js'
import PlayerClick from '../Message/Outgoing/PlayerClick.js'

class ControlledPlayer extends Player {
    
    constructor(id, game) {
        super(id)
        this.speedSize = 5;
        this.speed = new Vector(0, 0);
        this.game = game;
        
        this.keydownListener = document.addEventListener('keydown', (e) => {
            const code = e.keyCode;
            this.game.sendMessage(new PlayerKeyDown(String.fromCharCode(code)));
        });
        
        this.keyupListener = document.addEventListener('keyup', (e) => {
            const code = e.keyCode;
            this.game.sendMessage(new PlayerKeyUp(String.fromCharCode(code)));
        });
        
        this.clickListener = document.addEventListener('click', (e) => {
            let x;
            let y;
            if (e.pageX || e.pageY) { 
              x = e.pageX;
              y = e.pageY;
            } else { 
              x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft; 
              y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop; 
            } 
            
            const canvas = game.getCanvas();
            x -= canvas.offsetLeft;
            y -= canvas.offsetTop;
            
            if(x >= 0 && x <= canvas.width && y >= 0 && y <= canvas.height) {
                this.game.sendMessage(new PlayerClick(x, y));
            }
        });
    }

    
}

export default ControlledPlayer
